/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timeline_Split_Event_TitleInputs */

const en_timeline_split_event_title = /** @type {(inputs: Timeline_Split_Event_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Split Event`)
};

const fr_timeline_split_event_title = /** @type {(inputs: Timeline_Split_Event_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diviser l'evenement`)
};

const de_timeline_split_event_title = /** @type {(inputs: Timeline_Split_Event_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Split Event`)
};

const it_timeline_split_event_title = /** @type {(inputs: Timeline_Split_Event_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evento diviso`)
};

const ru_timeline_split_event_title = /** @type {(inputs: Timeline_Split_Event_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Разделенное событие`)
};

const es_timeline_split_event_title = /** @type {(inputs: Timeline_Split_Event_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evento dividido`)
};

const zh_cn2_timeline_split_event_title = /** @type {(inputs: Timeline_Split_Event_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分裂事件`)
};

const ja_timeline_split_event_title = /** @type {(inputs: Timeline_Split_Event_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分割イベント`)
};

const hi_timeline_split_event_title = /** @type {(inputs: Timeline_Split_Event_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`विभाजन घटना`)
};

const pt_pt2_timeline_split_event_title = /** @type {(inputs: Timeline_Split_Event_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evento dividido`)
};

/**
* | output |
* | --- |
* | "Split Event" |
*
* @param {Timeline_Split_Event_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timeline_split_event_title = /** @type {((inputs?: Timeline_Split_Event_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeline_Split_Event_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_timeline_split_event_title(inputs)
	if (locale === "de") return de_timeline_split_event_title(inputs)
	if (locale === "it") return it_timeline_split_event_title(inputs)
	if (locale === "ru") return ru_timeline_split_event_title(inputs)
	if (locale === "es") return es_timeline_split_event_title(inputs)
	if (locale === "zh-CN") return zh_cn2_timeline_split_event_title(inputs)
	if (locale === "ja") return ja_timeline_split_event_title(inputs)
	if (locale === "hi") return hi_timeline_split_event_title(inputs)
	if (locale === "pt-PT") return pt_pt2_timeline_split_event_title(inputs)
	return en_timeline_split_event_title(inputs)
});